'use strict';

import moment from 'moment';

function DueDateColorDirective() {
  return {
    restrict: 'A',
    scope: {
      dueAt: '<',
      completedAt: '<'
    },
    link: function(scope, element) {
      scope.$watch('dueAt', () => {
        if (scope.completedAt) {
          element.addClass('done-color');
        } else {
          if (scope.dueAt && moment(scope.dueAt).isSame(moment(), 'day')) {
            element.addClass('last-day-color');
          } else if (
            scope.dueAt &&
            moment(scope.dueAt).isBefore(moment(), 'day')
          ) {
            element.addClass('expired-color');
          }
        }
      });
    }
  };
}

export default DueDateColorDirective;
